import React from "react";
import { Row, Col, Button, Card } from "react-bootstrap";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Zoom } from "react-awesome-reveal";
// import { ReceiptCutoff, CalendarCheck } from 'react-bootstrap-icons';

function SkeletonOrderDetail() {
  return (
    <SkeletonTheme baseColor="#cecdcd" highlightColor="#e2dfdf">
      <Col xs={12} lg={7} className="pr-lg-0">
        {/* repeat start */}

        <Card className="w-100  rounded-3 mb-3 shadow-sm ">
          <Card.Body>
            <Row>
              <Col xs={12}>
                <Row>
                  <Col xs="auto" className="position-relative">
                    <Skeleton width={70} height={54} className="mt-0" />
                  </Col>
                  <Col className="ps-0 my-auto" style={{ lineHeight: "19px" }}>
                    <Skeleton width={70} height={15} />
                    <Skeleton width={120} height={15} />
                    <Skeleton width={50} height={15} />
                  </Col>
                  <Col xs={12} className="border-top pt-2 mx-0 mt-2">
                    <Row className="my-2">
                      <Col xs="auto" className="pe-0 text-muted">
                        تاریخ استفاده از تفریح
                      </Col>
                      <Col className="my-auto opacity-10">
                        <div
                          style={{
                            borderTop: "1px dashed #000",
                            height: "1px",
                          }}
                        ></div>
                      </Col>
                      <Col xs="auto" className="text-end text-dark ">
                        <Skeleton width={50} height={15} />
                      </Col>
                    </Row>

                    <Row className="my-2">
                      <Col xs="auto" className="pe-0 text-muted">
                        مبلغ آیتم
                      </Col>
                      <Col className="my-auto opacity-10">
                        <div
                          style={{
                            borderTop: "1px dashed #000",
                            height: "1px",
                          }}
                        ></div>
                      </Col>
                      <Col xs="auto" className="text-end text-dark medium-svg">
                        <Skeleton width={50} height={15} />
                      </Col>
                    </Row>

                    <Row className="my-2">
                      <Col xs="auto" className="pe-0 text-muted">
                        تعداد بلیط
                      </Col>
                      <Col className="my-auto opacity-10">
                        <div
                          style={{
                            borderTop: "1px dashed #000",
                            height: "1px",
                          }}
                        ></div>
                      </Col>
                      <Col xs="auto" className="text-end text-dark ">
                        <Skeleton width={50} height={15} />
                      </Col>
                    </Row>
                    <Row className="my-2">
                      <Col xs="auto" className="pe-0 text-muted">
                        مبلغ کل{" "}
                      </Col>
                      <Col className="my-auto opacity-10">
                        <div
                          style={{
                            borderTop: "1px dashed #000",
                            height: "1px",
                          }}
                        ></div>
                      </Col>
                      <Col xs="auto" className="text-end text-dark medium-svg">
                        <Skeleton width={50} height={15} />
                      </Col>
                    </Row>

                    <Row className="my-2">
                      <Col xs="auto" className="pe-0 text-muted">
                        وضعیت
                      </Col>
                      <Col className="my-auto opacity-10">
                        <div
                          style={{
                            borderTop: "1px dashed #000",
                            height: "1px",
                          }}
                        ></div>
                      </Col>
                      <Col xs="auto" className="text-end">
                        <Skeleton width={50} height={15} />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Card.Body>
          <Card.Footer className="border-top-0 bg-light-1">
            <div className="d-flex flex-wrap  align-items-center">
              <Skeleton width={70} height={28} className="me-1" />
              <Skeleton width={70} height={28} className="me-1" />
              <Skeleton width={70} height={28} />
            </div>
          </Card.Footer>
        </Card>

        {/* repeat end */}
      </Col>
    </SkeletonTheme>
  );
}

export default SkeletonOrderDetail;
